export enum EImageInputType {
  Link,
  Caption,
}
